import { render, staticRenderFns } from "./how-to-download-instagram-reels-to-your-phone.vue?vue&type=template&id=65339ba1"
import script from "./how-to-download-instagram-reels-to-your-phone.vue?vue&type=script&lang=js"
export * from "./how-to-download-instagram-reels-to-your-phone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports